import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import PublicationCreateActions from '../Redux/PublicationCreateRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function* getPublicationCreate(api, authApi, {id}) {
  try {
    const response = yield call(api.getPublicationCreate, id)
    if (response && response.ok) {
      yield put(PublicationCreateActions.publicationCreateSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPublicationCreate(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deletePublicationCreate(api, authApi, {id, data}) {
  try {
    const response = yield call(api.deletePublicationCreate, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.deletePublicationCreateSuccess(true, id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deletePublicationCreate(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* savePublicationCreate(api, authApi, {id, data}) {
  try {
    const response = yield call(api.savePublicationCreate, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.savePublicationCreateSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* savePublicationCreate(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveSeller(api, authApi, {id, data}) {
  try {
    const response = yield call(api.saveSeller, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.saveSellerSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveSeller(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateSeller(api, authApi, {id, data}) {
  try {
    const response = yield call(api.updateSeller, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.updateSellerSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateSeller(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteSeller(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteSeller, id)
    if (response && response.ok) {
      yield put(PublicationCreateActions.deleteSellerSuccess(id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteSeller(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveSupplier(api, authApi, {id, data}) {
  try {
    const response = yield call(api.saveSupplier, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.saveSupplierSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveSupplier(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateSupplier(api, authApi, {id, data}) {
  try {
    const response = yield call(api.updateSupplier, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.updateSupplierSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateSupplier(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteSupplier(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteSupplier, id)
    if (response && response.ok) {
      yield put(PublicationCreateActions.deleteSupplierSuccess(id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteSupplier(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

/**/

export function* saveMedia(api, authApi, {id, data}) {
  try {
    const response = yield call(api.saveMedia, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.saveMediaSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveMedia(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateMedia(api, authApi, {id, data}) {
  try {
    const response = yield call(api.updateMedia, id, data)
    if (response && response.ok) {
      yield put(PublicationCreateActions.updateMediaSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateMedia(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteMedia(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteMedia, id)
    if (response && response.ok) {
      yield put(PublicationCreateActions.deleteMediaSuccess(id))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationCreateActions.publicationCreateFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteMedia(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationCreateActions.publicationCreateFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
